import Gamer from "../../shared/assets/images/beard-guy.jpg";
import Arrow from "../../shared/assets/images/Arrow.png";
import cls from "./Main.module.css";
import Title from "../../shared/ui/Title/Title";
import ParagraphSection from "../../shared/ui/ParagraphSection/ParagraphSection";
import MarginBottomContainer from "../../shared/ui/MarginBottomContainer/MarginBottomContainer";
import ScrollButton from "../../shared/ui/ScrollButton/ScrollButton";
const Main = () => {
    console.log(cls);
    return (
        <div id="main" className={cls.mainSection}>
            <div className="container container--main">
                <div className={cls.mainWrapper}>
                    <div className={cls.mainWrapper__info}>
                        <MarginBottomContainer margin={22}>
                            <Title title="A Performance-Driven Digital Marketing Agency" />
                        </MarginBottomContainer>

                        <MarginBottomContainer margin={123}>
                            <ParagraphSection>
                                We help brands accelerate growth through high-converting CPA campaigns across Google, Facebook, and beyond. Our team transforms traffic into tangible results — leads, sales, and profit.
                            </ParagraphSection>
                        </MarginBottomContainer>
                        <ScrollButton src={Arrow} href="aboutUs" label="ABOUT US" />

                    </div>
                    <div>
                        <img src={Gamer} alt="" class={cls.mainBlockPicture} />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Main;
